import { AxiosResponse } from 'axios'
import DataTypeModel from '../../../../models/DataType'
import { Lookup } from '../../../interfaces/Lookup'
import { get, post, put } from '../../../methods'
import apiUrl from '../../../Url/ApiUrl'

export const getTempoLanguages = <T>(): Promise<AxiosResponse<T>> => get(apiUrl.languages.tempoLanguagesList)

export const getTempoTerminologyLanguages = <T>(): Promise<AxiosResponse<T>> =>
    get(apiUrl.languages.tempoTerminologyLanguagesList)

export const getTempoServices = <T>(): Promise<AxiosResponse<T>> => get(apiUrl.services.tempoServicesList)

export const getTempoCostCenters = (customerForEntityId: number): Promise<AxiosResponse<Lookup[]>> =>
    get(
        apiUrl.costCenters.tempoCostCentersList,
        DataTypeModel(
            {
                customerForEntityId,
            },
            {},
        ),
    )

export const getTempoCustomers = (): Promise<AxiosResponse<any[]>> => get(apiUrl.customers.tempoCustomersList)

export const getTempoDocumentTypes = (customerForEntityId: number): Promise<AxiosResponse<Lookup[]>> =>
    get(
        apiUrl.documentTypes.tempoDocumentTypesList,
        DataTypeModel(
            {
                customerForEntityId,
            },
            {},
        ),
    )

export const getTempoRequestingEntities = (customerForEntityId: number): Promise<AxiosResponse<Lookup[]>> =>
    get(
        apiUrl.requestingEntities.tempoRequestingEntitiesList,
        DataTypeModel(
            {
                customerForEntityId,
            },
            {},
        ),
    )

export const getTempoRequestTypes = (customerForEntityId: number): Promise<AxiosResponse<Lookup[]>> =>
    get(
        apiUrl.requestTypes.tempoRequestTypesList,
        DataTypeModel(
            {
                customerForEntityId,
            },
            {},
        ),
    )

export const getDeclineReason = (): Promise<AxiosResponse<Lookup[]>> => get(apiUrl.declineReason.tempoDeclineReason)

export const getCollections = (): Promise<AxiosResponse<Lookup[]>> => get(apiUrl.collections.tempoCollections)

export const getStatus = (): Promise<AxiosResponse<Lookup[]>> => get(apiUrl.validation.tempoStatus)

export const getValidators = (): Promise<AxiosResponse<Lookup[]>> => get(apiUrl.validation.tempoValidators)

export const getResponsibles = (): Promise<AxiosResponse<Lookup[]>> => get(apiUrl.validation.tempoResponsibles)

export const checkEmail = (requestBody: { email: string }): Promise<AxiosResponse<Record<string, any>>> =>
    post(apiUrl.auth.checkEmail.tempoCheckEmail, DataTypeModel(requestBody))

export const sendResetPasswordEmail = (requestBody: { email: string }): Promise<AxiosResponse<Record<string, any>>> =>
    post(apiUrl.auth.sendResetPasswordEmail.tempoSendResetPasswordEmail, DataTypeModel(requestBody))

export const resetPassword = (requestBody: {
    userId: string
    password: string
}): Promise<AxiosResponse<Record<string, any>>> =>
    put(apiUrl.auth.resetPassword.tempoResetPassword, DataTypeModel(requestBody))
